/**
 * RegisterPage.jsx
 *
 * Page d'inscription avec Ant Design
 */

import React, { useState } from "react";
import { Form, Input, Button, Card, Space, message } from "antd";
import { useNavigate } from "react-router-dom";
import { registerUser } from "../api/api";
import { useAuth } from "../context/AuthContext";
import { useTheme } from "../context/ThemeContext";

/**
 * RegisterPage - Création de compte
 */
export default function RegisterPage() {
    const navigate = useNavigate();
    const { login } = useAuth();
    const { isDarkMode } = useTheme();
    const [loading, setLoading] = useState(false);
    const [form] = Form.useForm();

    const handleSubmit = async (values) => {
        if (values.password !== values.confirmPassword) {
            message.error("Les mots de passe ne correspondent pas");
            return;
        }

        try {
            setLoading(true);
            const res = await registerUser(values.login, values.password);
            login(res.data.token, { login: values.login });
            message.success("Compte créé !");
            navigate("/");
        } catch (err) {
            message.error(err.response?.data?.error || "Erreur création compte");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div
            style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                minHeight: "100vh",
                padding: "16px",
                background: isDarkMode ? "#000000" : "#fafafa",
            }}
        >
            <Card
                style={{
                    width: "100%",
                    maxWidth: "400px",
                    background: isDarkMode ? "#1f1f1f" : "#ffffff",
                }}
            >
                <Space direction="vertical" style={{ width: "100%" }}>
                    <h2 style={{ textAlign: "center", margin: "0 0 24px" }}>
                        Créer un compte
                    </h2>

                    <Form
                        form={form}
                        layout="vertical"
                        onFinish={handleSubmit}
                    >
                        <Form.Item
                            label="Identifiant"
                            name="login"
                            rules={[{ required: true, message: "Requis" }]}
                        >
                            <Input placeholder="Choisis un identifiant" size="large" />
                        </Form.Item>

                        <Form.Item
                            label="Mot de passe"
                            name="password"
                            rules={[{ required: true, message: "Requis" }]}
                        >
                            <Input.Password placeholder="Choisis un mot de passe" size="large" />
                        </Form.Item>

                        <Form.Item
                            label="Confirmer le mot de passe"
                            name="confirmPassword"
                            rules={[{ required: true, message: "Requis" }]}
                        >
                            <Input.Password placeholder="Confirme le mot de passe" size="large" />
                        </Form.Item>

                        <Button
                            type="primary"
                            htmlType="submit"
                            loading={loading}
                            block
                            size="large"
                        >
                            Créer le compte
                        </Button>
                    </Form>

                    <div style={{ textAlign: "center", fontSize: "14px" }}>
                        Déjà inscrit ?{" "}
                        <a href="/login" style={{ color: "#1890ff" }}>
                            Se connecter
                        </a>
                    </div>
                </Space>
            </Card>
        </div>
    );
}